/* eslint-disable
    consistent-return,
    no-return-assign,
    no-shadow,
    no-unused-vars,
    one-var
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import * as d3 from 'd3';
import _ from 'underscore';

import Backdrop from 'components/Backdrop';
import * as colors from 'lib/Colors';

/**
 * TODO (BNCH-47280): Remove all usages of this component and replace with `client/molbio/sequence-features/PopoverColorPicker.tsx`
 * @deprecated
 */
class ColorPicker extends Backdrop {
  static initClass() {
    this.prototype.className = 'color-picker';

    this.prototype.events = {'click .selector': '_changePalette'};
  }

  initialize(options) {
    super.initialize({closeOnScroll: true});
    if (options) {
      ({multiple: this.multiple} = options);
    }
    if (this.model != null && this.multiple) {
      // if a model is passed, use it as a scope - only one color picker should ever be open
      // in the scope at the time
      this.listenTo(this.model, 'closeColorPicker', this.hide);
    }

    this.coloredItem = undefined;
    this.colorPalette = colors.pastelColors;

    this._render(d3.select(this.el));
    const root = d3.select(this.el);

    root.on('mousedown', (e) => {
      e.stopPropagation();
    });

    root
      .append('input')
      .attr('type', 'checkbox')
      .property('checked', true)
      .on('click.color-picker', (e) => {
        e.stopPropagation();
      })
      .on('change.color-picker', (e) => {
        if (e.target.checked) {
          this.colorPalette = colors.pastelColors;
        } else {
          this.colorPalette = colors.oldPastelColors;
        }
        this._render(d3.select(this.el));
      });
    return root.append('span').classed('new-palette', true).text('use new palette');
  }

  die() {
    this.stopListening();
    this.undelegateEvents();
    d3.select(this.el).select('input').on('.color-picker', null);
  }

  _render(el) {
    const rowdata = _.chain(this.colorPalette)
      .groupBy((color, index) => Math.floor(index / 4))
      .values()
      .value();

    const rows = d3.select(this.el).selectAll('div.row').data(rowdata);
    rows.join('div').classed('row', true);

    const css = (d, event) => {
      let active, k, style;
      if (this.coloredItem != null) {
        active = d3.rgb(d).formatHex() === d3.rgb(this.coloredItem.get('color')).formatHex();
      }
      if (active) {
        k = 2;
      } else if (event === 'mouseover') {
        k = 1;
      } else {
        k = 0;
      }
      const darker = d3.rgb(d).darker(k).formatHex();
      return (style = `background-color: ${d}; border: 2px solid ${darker}`);
    };

    const cols = rows.selectAll('div.col').data((d) => d);
    return cols
      .join('div')
      .classed('col col-md-3', true)
      .attr('data-color', (d) => d)
      .attr('style', (d) => css(d))
      .on('click', (e, d) => {
        e.stopPropagation();
        this.$target.trigger('change', d);
        if (this.coloredItem != null) {
          this.coloredItem.set({color: d});
        }
        if (this.coloredItem != null) {
          this.coloredItem.trigger('colorPickerChange');
        }
        return this.model != null ? this.model.trigger('colorPickerChange', e, d) : undefined;
      })
      .on('mouseover', function (e, d) {
        return d3.select(this).attr('style', (d) => css(d, 'mouseover'));
      })
      .on('mouseleave', function (e, d) {
        return d3.select(this).attr('style', (d) => css(d, 'mouseleave'));
      });
  }

  open() {
    if (this.multiple) {
      if (this.model != null) {
        this.model.trigger('closeColorPicker');
      }
    }
    super.open();
    this.$target.before(this.overlay);
    return this.el;
  }

  close(hidePopover) {
    if (hidePopover == null) {
      hidePopover = true;
    }
    super.close();
    if (hidePopover) {
      return this.$target.popover('hide');
    }
  }

  update(coloredItem) {
    this.coloredItem = coloredItem;
    return this._render(this.el);
  }

  attach($target, trigger, container, placement) {
    if (container == null) {
      container = false;
    }
    if (placement == null) {
      placement = 'left';
    }
    const $popover = $target
      .popover({
        title: 'Select Color',
        trigger,
        // eslint-disable-next-line no-restricted-syntax
        content: _.bind(this.open, this),
        placement,
        html: true,
        container,
      }) // eslint-disable-next-line no-restricted-syntax
      .on('hide.bs.popover', _.bind(this.close, this, false));

    return (this.$target = $target);
  }
}

ColorPicker.initClass();

export default ColorPicker;
